import { getLabel } from "../labels";

export function getMonthsLabelsShort() {
    const months = [
        getLabel('general.months.short..jan', 'Gen'),
        getLabel('general.months.short..feb', 'Feb'),
        getLabel('general.months.short..mar', 'Mar'),
        getLabel('general.months.short..apr', 'Apr'),
        getLabel('general.months.short..may', 'Mag'),
        getLabel('general.months.short..jun', 'Giu'),
        getLabel('general.months.short..jul', 'Lug'),
        getLabel('general.months.short..aug', 'Ago'),
        getLabel('general.months.short..sep', 'Set'),
        getLabel('general.months.short..oct', 'Ott'),
        getLabel('general.months.short..nov', 'Nov'),
        getLabel('general.months.short..dec', 'Div'),
    ];

    return months;
}
